var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            {
              staticClass: "demo-form-inline",
              attrs: { inline: true, model: _vm.searchForm, size: "small" },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "130px" },
                    attrs: {
                      type: "month",
                      placeholder: "请选择月份",
                      "value-format": "yyyy-MM",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchForm.month,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "month", $$v)
                      },
                      expression: "searchForm.month",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "250px" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      "value-format": "yyyy-MM-dd",
                      "picker-options": _vm.pickerOptions,
                      clearable: false,
                    },
                    model: {
                      value: _vm.submitTime,
                      callback: function ($$v) {
                        _vm.submitTime = $$v
                      },
                      expression: "submitTime",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("DynamicOption", {
                    attrs: {
                      placeholder: "全部应用",
                      singleSelect: true,
                      params: _vm.searchOptions,
                    },
                    model: {
                      value: _vm.searchForm.aid,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "aid", $$v)
                      },
                      expression: "searchForm.aid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "全部版本", clearable: "" },
                      model: {
                        value: _vm.searchForm.sdkv,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "sdkv", $$v)
                        },
                        expression: "searchForm.sdkv",
                      },
                    },
                    _vm._l(_vm.versionList, function (item) {
                      return _c("el-option", {
                        key: item,
                        attrs: { label: item, value: item },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "全部产品类型", clearable: "" },
                      model: {
                        value: _vm.searchForm.productId,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "productId", $$v)
                        },
                        expression: "searchForm.productId",
                      },
                    },
                    _vm._l(_vm.clientTypes, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入厂商标志", clearable: "" },
                    model: {
                      value: _vm.searchForm.manufacturer,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "manufacturer", $$v)
                      },
                      expression: "searchForm.manufacturer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入设备型号", clearable: "" },
                    model: {
                      value: _vm.searchForm.unitType,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "unitType", $$v)
                      },
                      expression: "searchForm.unitType",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入芯片名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.chipName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "chipName", $$v)
                      },
                      expression: "searchForm.chipName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入系统版本号", clearable: "" },
                    model: {
                      value: _vm.searchForm.sysv,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "sysv", $$v)
                      },
                      expression: "searchForm.sysv",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入客户端版本号", clearable: "" },
                    model: {
                      value: _vm.searchForm.appv,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "appv", $$v)
                      },
                      expression: "searchForm.appv",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入UID", clearable: "" },
                    model: {
                      value: _vm.searchForm.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "uid", $$v)
                      },
                      expression: "searchForm.uid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入会议ID", clearable: "" },
                    model: {
                      value: _vm.searchForm.roomid,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "roomid", $$v)
                      },
                      expression: "searchForm.roomid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入投屏码", clearable: "" },
                    model: {
                      value: _vm.searchForm.code,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "code", $$v)
                      },
                      expression: "searchForm.code",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入HID", clearable: "" },
                    model: {
                      value: _vm.searchForm.hid,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "hid", $$v)
                      },
                      expression: "searchForm.hid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "发送端CID(IMEI或IDFA)",
                      clearable: "",
                    },
                    model: {
                      value: _vm.searchForm.cid,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "cid", $$v)
                      },
                      expression: "searchForm.cid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入MAC地址", clearable: "" },
                    model: {
                      value: _vm.searchForm.mac,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "mac", $$v)
                      },
                      expression: "searchForm.mac",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入手机号码", clearable: "" },
                    model: {
                      value: _vm.searchForm.pn,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "pn", $$v)
                      },
                      expression: "searchForm.pn",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入双端关联ID", clearable: "" },
                    model: {
                      value: _vm.searchForm.euqid,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "euqid", $$v)
                      },
                      expression: "searchForm.euqid",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handleExport },
                    },
                    [_vm._v("导出")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          attrs: {
            "cell-style": { "text-align": "center" },
            "header-cell-style": { "text-align": "center" },
            "max-height": _vm.tableHeight,
            "element-loading-text": "加载中",
            border: "",
            data: _vm.tableData,
            "row-style": { height: "30px" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80" },
          }),
          _c("el-table-column", {
            attrs: { prop: "aid", label: "应用名称", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.aid,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.aid)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "sysv", label: "系统版本", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "appv", label: "客户端版本", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "roomid", label: "会议id", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.roomid))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "code", label: "投屏码", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.code))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "ct", label: "客户端类型", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.ct))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "createTime", label: "上报时间", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { prop: "euqid", label: "双端关联ID", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.euqid,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.euqid)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "et", label: "问题类型", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "manufacturer", label: "厂商", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "unitType", label: "设备型号", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.unitType,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.unitType)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "chipName", label: "芯片名称", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.chipName,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.chipName)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "productName", label: "产品类型", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "sdkv", label: "SDK版本号", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.sdkv,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.sdkv)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "uid", label: "UID", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.uid,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.uid)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "hid", label: "HID", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.hid,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.hid)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "cid", label: "CID", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.cid))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "mac", label: "MAC", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.mac,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.mac)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "context", label: "问题描述", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: scope.row.context,
                          placement: "top",
                        },
                      },
                      [
                        _c("span", { staticClass: "ellipsis-text" }, [
                          _vm._v(_vm._s(scope.row.context)),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "video", label: "视频链接", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.video
                      ? _c(
                          "el-link",
                          {
                            attrs: {
                              type: "primary",
                              href: scope.row.video,
                              target: "_blank",
                            },
                          },
                          [_vm._v("查看视频")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "images", label: "图片链接", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.images
                      ? _c(
                          "el-link",
                          {
                            attrs: {
                              type: "primary",
                              href: scope.row.images,
                              target: "_blank",
                            },
                          },
                          [_vm._v("查看图片")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "pn", label: "手机号", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.pn))])]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作", fixed: "right", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.logfileurl
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownload(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          下载\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table_pagination" },
        [
          _c("el-pagination", {
            staticClass: "app-pagination",
            attrs: {
              background: "",
              "current-page": _vm.pageNo,
              "page-sizes": _vm.pageSizeArr,
              "page-size": _vm.pageSize,
              layout: _vm.paginationLayout,
              total: _vm.totalCount,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }